import { PaymentRequestGetApprovalsUseCase } from '../../../application';

export default class PaymentRequestGetApprovalsService {

    async execute(event) {
        const data = await PaymentRequestGetApprovalsUseCase(event);
        return data;
    }
}
